import axios from 'axios';
import { attachTokenRefresh } from "@/utils/authInterceptors";
import { notify } from "@/utils/notify.js";
import store from "@/store";

const wrapURL = (URL) => {
    const baseURL = axios.create({
        baseURL:URL
    });

    baseURL.interceptors.request.use(
        function (config) {
            let token = store?.state?.login?.token || "";
            config.headers.Authorization = token ? `Bearer ${token}` : "";
            return config;
        },
        function (error) {
            return Promise.reject(error);
        },
    );

    baseURL.interceptors.response.use(
        (response) => {
            if (response.status !== 200 && response.status !== 201) {
                if (response.status != 204) {
                    //only show error notification if status is not 204
                    //if 204: only throw error
                    notify({
                        title: "Error",
                        message: response.message,
                        type: "error",
                        duration: 5000,
                    });
                }
                return Promise.reject("error");
            } else {
                return response;
            }
        },
        (error) => {
            notify({
                title: "Error",
                message: error?.response?.data?.message ?? error?.message,
                type: "error",
                duration: 5000,
            });
            console.log(error);
            return Promise.reject(error);
            
        }
    );
    attachTokenRefresh(baseURL);
    return baseURL;
}

export default wrapURL;